import { useAsyncFn } from 'react-use';

import { sendVerificationEmail } from 'supertokens-auth-react/recipe/emailverification';

import { useSession } from '../useSession/useSession.hook';

export const useResendEmail = () => {
  const [{ userId }] = useSession();

  return useAsyncFn(async () => {
    const { status } = await sendVerificationEmail({ userContext: { userId } });
    if (status === 'OK') {
      return true;
    } else if (status === 'EMAIL_ALREADY_VERIFIED_ERROR') {
      throw new Error('Email already verified');
    }
  });
};
